import { Button } from "components/buttons/Button";
import { Tooltip } from "components/tooltip/Tooltip";
import { PulseCircle } from "components/UI/PulseCircle";
import { FSButton } from "components/buttons/FSButton";
import { useRef, memo } from "react";
import "./FullScreenButton.scss";
import { useFsTooltip } from "./hooks/useFsTooltip";

interface IFullScreenButton {
  fullscreen: boolean;
  onFullScreen: () => void;
  position: number;
  isVisible: boolean;
}

export const FullScreenButton = memo(({
  fullscreen,
  onFullScreen,
  position,
  isVisible,
}: IFullScreenButton) => {
  const refs = useRef<HTMLLIElement>(null);

  const { isShowFsTooltip, onDismissFsTooltip } = useFsTooltip({ position, isVideoVisible: isVisible });

  const onEnterFSandCloseTooltip = () => {
    onDismissFsTooltip(false);
    onFullScreen();
  };

  return (
    <li className="SideBar-Item SideBar-Item_isFullScreenItem" ref={refs}>
      {isShowFsTooltip && <PulseCircle />}
      <FSButton fullscreen={fullscreen} onClick={onEnterFSandCloseTooltip} />
      {isShowFsTooltip &&
        <Tooltip
          className="FsTooltip"
          onClose={() => onDismissFsTooltip(true)}
          position={"topRight"}
          anchorEl={refs.current}
          active={isShowFsTooltip}
        >
          <span>Tap to enjoy <br /> RedGIFs <br /> in Full Screen ❤️</span>
          <Button variant="primary" size="xs" onClick={() => onDismissFsTooltip(false)}>Got it</Button>
        </Tooltip>}
    </li>
  );
});
